const subdomainConfigs = {
  default: {
    companyName: 'SmartBites',
    theme: {
      primaryColor: '#4CAF50',
      secondaryColor: '#2196F3',
      backgroundColor: '#ffffff',
      textColor: '#333333'
    },
    branding: {
      logo: '/logos/default-logo.png',
      title: 'SmartBites',
      tagline: 'Smart Food Recommendations'
    }
  },
  juicy: {
    companyName: 'Juicy',
    theme: {
      primaryColor: 'rgb(228, 83, 81)',    // Coral red - matches existing CSS
      secondaryColor: 'rgb(198, 63, 60)',  // Darker coral - matches existing CSS  
      backgroundColor: '#ffffff',          // White background
      textColor: '#2d3748'                 // Dark gray text
    },
    branding: {
      logo: '/JuicyLogo.png',
      title: 'Juicy',
      tagline: 'Fresh Juice & Smoothie Bar'
    },
    featuredProducts: [
      {
        id: "featured_1",
        item_name: "Strawberry Quick",
        base_price: 6.99,
        description: "A sweet and refreshing blend of ripe strawberries, tropical pineapple, and a hint of spicy ginger for a burst of flavor and energy.",
        category: "drink",
        image: "StrawberryQuick.jpg",
        calories: 350,
        health_benefits: "Rich in antioxidants, supports digestion, and boosts immunity.",
        macros: {
          protein: 3,
          carbs: 84,
          fats: 5
        },
        sizes: {
          regular: { price_diff: 0 },
          large: { price_diff: 1.5 }
        },
        add_ons: [{ name: "Protein Scoop", price: 2 }]
      },
      {
        id: "featured_2", 
        item_name: "The Hulk",
        base_price: 6.99,
        description: "A revitalizing juice featuring a mix of pineapple, cucumber, green apple, and lemon, providing a refreshing and cooling effect.",
        category: "drink",
        image: "TheHulk.jpg",
        calories: 350,
        health_benefits: "Detoxifies the body and replenishes hydration with vital nutrients.",
        macros: {
          protein: 3,
          carbs: 83,
          fats: 5
        },
        sizes: {
          regular: { price_diff: 0 },
          large: { price_diff: 1.5 }
        },
        add_ons: [{ name: "Protein Scoop", price: 2 }]
      },
      {
        id: "featured_3",
        item_name: "Juicylicious",
        base_price: 6.99,
        description: "A hydrating and juicy mix of watermelon, pineapple, and a kick of ginger for a sweet, tropical treat with a hint of spice.",
        category: "drink",
        image: "Juicylicious.jpg",
        calories: 320,
        health_benefits: "Hydrating and refreshing with natural electrolytes.",
        macros: {
          protein: 2,
          carbs: 76,
          fats: 2
        },
        sizes: {
          regular: { price_diff: 0 },
          large: { price_diff: 1.5 }
        },
        add_ons: [{ name: "Protein Scoop", price: 2 }]
      },
      {
        id: "featured_4",
        item_name: "Orange Juice", 
        base_price: 6.99,
        description: "A classic, tangy, and refreshing juice made with organic oranges, offering a burst of vitamin C and citrus goodness.",
        category: "drink",
        image: "OrangeJuice.jpg",
        calories: 250,
        health_benefits: "Boosts immune system and provides hydration with natural electrolytes.",
        macros: {
          protein: 2,
          carbs: 60,
          fats: 1
        },
        sizes: {
          regular: { price_diff: 0 },
          large: { price_diff: 1.5 }
        },
        add_ons: [{ name: "Protein Scoop", price: 2 }]
      },
      {
        id: "featured_5",
        item_name: "Twisty Green",
        base_price: 6.99,
        description: "A wholesome and energizing blend of kale, pineapple, red apple, and celery, providing a rich source of greens and antioxidants.",
        category: "drink",
        image: "TwistyGreen.jpg",
        calories: 270,
        health_benefits: "Supports detoxification and provides antioxidant protection.",
        macros: {
          protein: 4,
          carbs: 61,
          fats: 3
        },
        sizes: {
          regular: { price_diff: 0 },
          large: { price_diff: 1.5 }
        },
        add_ons: [{ name: "Protein Scoop", price: 2 }]
      }
    ],
    presetQuestions: {
      suggested: [
        "Something refreshing packed with vitamin C 🍊",
        "A sweet and fruity beverage to satisfy my cravings 🍓",
        "An energizing drink to power through my day ⚡",
        "A healthy green juice for my wellness goals 🥬"
      ],
      flavors: [
        "Citrusy and zesty flavors 🍋",
        "Sweet berry combinations 🫐",
        "Tropical fruit medley 🥭",
        "Green apple and mint freshness 🍏"
      ],
      nutrition: [
        "High protein smoothie for post-workout 💪",
        "Low sugar option under 150 calories ⚖️",
        "Antioxidant-rich superfood blend 🌟",
        "Immune-boosting vitamin packed drink 🛡️"
      ],
      dietary: [
        "Vegan-friendly options 🌱",
        "Gluten-free beverages 🚫🌾",
        "Dairy-free smoothies 🥛❌",
        "Nut-free alternatives 🥜❌"
      ],
      adventurous: [
        "Something unique I've never tried before 🎲",
        "Spicy and bold flavor combinations 🌶️",
        "Vegetable-forward green juice challenge 🥒",
        "Exotic fruit I can't pronounce 🌺"
      ]
    }
  },
  mpizza: {
    companyName: 'Manhattan Pizza',
    theme: {
      primaryColor: '#dc2626',        // Bright red (main color)
      secondaryColor: '#991b1b',      // Darker red
      backgroundColor: '#ffffff',     // White background
      textColor: '#1f2937'           // Dark gray text
    },
    branding: {
      logo: '/MPizzaLogo.png',
      title: 'Manhattan Pizza',
      tagline: 'Authentic New York Style Pizza'
    },
    featuredProducts: [
      {
        id: "pizza_featured_1",
        item_name: "Classic Margherita",
        base_price: 18.99,
        description: "Fresh mozzarella, San Marzano tomatoes, fresh basil, and olive oil on our signature thin crust.",
        category: "pizza",
        image: "Margherita.jpg",
        calories: 650,
        health_benefits: "Rich in calcium and protein, made with fresh ingredients.",
        macros: {
          protein: 28,
          carbs: 78,
          fats: 22
        },
        sizes: {
          small: { price_diff: -4 },
          medium: { price_diff: 0 },
          large: { price_diff: 4 }
        },
        add_ons: [
          { name: "Extra Cheese", price: 2.50 },
          { name: "Pepperoni", price: 3.00 },
          { name: "Mushrooms", price: 2.00 }
        ]
      },
      {
        id: "pizza_featured_2",
        item_name: "Manhattan Supreme",
        base_price: 24.99,
        description: "Our signature pizza loaded with pepperoni, Italian sausage, mushrooms, bell peppers, onions, and olives.",
        category: "pizza",
        image: "ManhattanSupreme.jpg",
        calories: 850,
        health_benefits: "High protein content with a variety of vegetables.",
        macros: {
          protein: 38,
          carbs: 82,
          fats: 35
        },
        sizes: {
          small: { price_diff: -6 },
          medium: { price_diff: 0 },
          large: { price_diff: 6 }
        },
        add_ons: [
          { name: "Extra Cheese", price: 2.50 },
          { name: "Extra Meat", price: 4.00 }
        ]
      },
      {
        id: "pizza_featured_3",
        item_name: "White Pizza Deluxe",
        base_price: 21.99,
        description: "Ricotta and mozzarella base with garlic, spinach, tomatoes, and grilled chicken.",
        category: "pizza",
        image: "WhitePizza.jpg",
        calories: 720,
        health_benefits: "High in calcium and protein with added vegetables.",
        macros: {
          protein: 35,
          carbs: 68,
          fats: 28
        },
        sizes: {
          small: { price_diff: -5 },
          medium: { price_diff: 0 },
          large: { price_diff: 5 }
        },
        add_ons: [
          { name: "Extra Chicken", price: 3.50 },
          { name: "Extra Spinach", price: 2.00 }
        ]
      }
    ],
    presetQuestions: {
      suggested: [
        "A classic New York style pizza 🍕",
        "Something with lots of meat and cheese 🥓",
        "A lighter option with vegetables 🥬",
        "Your most popular pizza recommendation 🌟"
      ],
      flavors: [
        "Traditional Italian flavors 🇮🇹",
        "Spicy and bold combinations 🌶️",
        "White sauce based pizzas 🧄",
        "BBQ and smoky flavors 🔥"
      ],
      nutrition: [
        "High protein pizza for athletes 💪",
        "Vegetable-loaded healthy option 🥗",
        "Lighter thin crust under 600 calories ⚖️",
        "Protein-packed meat lovers 🍖"
      ],
      dietary: [
        "Vegetarian options 🌱",
        "Gluten-free crust available 🚫🌾",
        "Low-carb cauliflower crust 🥬",
        "Dairy-free cheese options 🧀❌"
      ],
      adventurous: [
        "Something unique and creative 🎨",
        "Gourmet specialty pizzas 👨‍🍳",
        "Fusion flavors I've never tried 🌍",
        "Chef's special recommendation 👨‍🍳⭐"
      ]
    }
  },
  littlemexico: {
    companyName: 'Little Mexico',
    theme: {
      primaryColor: '#D2B48C',        // Tan color
      secondaryColor: '#A0522D',      // Darker tan/brown
      backgroundColor: '#ffffff',     // White background
      textColor: '#2d1810'           // Dark brown text
    },
    branding: {
      logo: '/LittleMexicoLogo.png',
      title: 'Little Mexico',
      tagline: 'Authentic Mexican Cuisine'
    },
    featuredProducts: [
      {
        id: "mexican_featured_1",
        item_name: "Mexican Street Corn",
        base_price: 6.50,
        description: "Grilled corn on the cob topped with chipotle mayo, cotija cheese, cilantro, and chile salt.",
        category: "appetizers",
        image: "MexicanStreetCorn.jpg",
        calories: 220,
        health_benefits: "Provides fiber and antioxidants from corn.",
        macros: {
          protein: 6,
          carbs: 28,
          fats: 12
        },
        sizes: {
          regular: { price_diff: 0 }
        },
        add_ons: [
          { name: "Extra Cotija Cheese", price: 1.50 }
        ]
      },
      {
        id: "mexican_featured_2",
        item_name: "Holy Guacamole",
        base_price: 11.00,
        description: "Fresh avocado mashed with jalapeño, lime, pico de gallo, and queso fresco.",
        category: "appetizers",
        image: "HolyGuacamole.jpg",
        calories: 310,
        health_benefits: "Rich in heart-healthy fats and vitamins.",
        macros: {
          protein: 6,
          carbs: 22,
          fats: 22
        },
        sizes: {
          regular: { price_diff: 0 }
        },
        add_ons: [
          { name: "Extra Chips", price: 2.00 }
        ]
      },
      {
        id: "mexican_featured_3",
        item_name: "Tinga Taquitos",
        base_price: 12.50,
        description: "Crispy rolled tortillas filled with chipotle chicken, topped with queso fresco, crema, lettuce, and pico de gallo.",
        category: "appetizers",
        image: "TingaTaquitos.jpg",
        calories: 430,
        health_benefits: "Balanced protein with fresh vegetables.",
        macros: {
          protein: 24,
          carbs: 36,
          fats: 18
        },
        sizes: {
          regular: { price_diff: 0 }
        },
        add_ons: [
          { name: "Extra Crema", price: 1.00 }
        ]
      },
      {
        id: "mexican_featured_4",
        item_name: "LilMex Bowl",
        base_price: 15.00,
        description: "Black beans, rice, pico, queso fresco, guacamole, crema, corn, lettuce, and tortilla chips with choice of protein.",
        category: "bowls",
        image: "LilMexBowl.jpg",
        calories: 520,
        health_benefits: "Packed with protein, fiber, and healthy fats.",
        macros: {
          protein: 30,
          carbs: 58,
          fats: 18
        },
        sizes: {
          chicken: { price_diff: 0 },
          steak: { price_diff: 1 },
          shrimp: { price_diff: 1 },
          trio: { price_diff: 3 }
        },
        add_ons: [
          { name: "Extra Guacamole", price: 2.00 }
        ]
      },
      {
        id: "mexican_featured_5",
        item_name: "Arroz Con Pollo",
        base_price: 16.00,
        description: "Rice with queso dip, flour tortillas, and your choice of chicken, steak, shrimp, or trio.",
        category: "bowls",
        image: "ArrozConPollo.jpg",
        calories: 560,
        health_benefits: "Protein-rich and satisfying.",
        macros: {
          protein: 32,
          carbs: 60,
          fats: 20
        },
        sizes: {
          chicken: { price_diff: 0 },
          steak: { price_diff: 1 },
          shrimp: { price_diff: 1 },
          trio: { price_diff: 3 }
        },
        add_ons: [
          { name: "Extra Queso Dip", price: 2.00 }
        ]
      },
      {
        id: "mexican_featured_6",
        item_name: "Carne Asada Fries",
        base_price: 12.00,
        description: "Crispy fries topped with steak, chipotle mayo, pico de gallo, cheese, and jalapeños.",
        category: "appetizers",
        image: "CarneAsadaFries.jpg",
        calories: 540,
        health_benefits: "High in protein, but indulgent.",
        macros: {
          protein: 28,
          carbs: 42,
          fats: 28
        },
        sizes: {
          regular: { price_diff: 0 }
        },
        add_ons: [
          { name: "Extra Steak", price: 3.00 }
        ]
      }
    ],
    presetQuestions: {
      suggested: [
        "Authentic Mexican tacos with fresh ingredients 🌮",
        "A hearty burrito or bowl to fill me up 🌯",
        "Something cheesy and comforting 🧀",
        "Your most popular Mexican dish 🌟"
      ],
      flavors: [
        "Spicy and bold Mexican flavors 🌶️",
        "Mild and family-friendly options 👨‍👩‍👧‍👦",
        "Smoky chipotle and grilled flavors 🔥",
        "Fresh and zesty lime combinations 🍋"
      ],
      nutrition: [
        "High protein options for athletes 💪",
        "Lighter options under 500 calories ⚖️",
        "Vegetarian Mexican dishes 🌱",
        "Protein-packed meat options 🥩"
      ],
      dietary: [
        "Vegetarian and vegan options 🌱",
        "Gluten-free corn tortilla dishes 🚫🌾",
        "Dairy-free options available 🥛❌",
        "Keto-friendly low-carb bowls 🥗"
      ],
      adventurous: [
        "Traditional Mexican street food 🛣️",
        "Spicy challenge level dishes 🔥🌶️",
        "Authentic regional specialties 🇲🇽",
        "Chef's special Mexican fusion 👨‍🍳⭐"
      ]
    }
  }
};

export default subdomainConfigs; 